import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetTrialIdentityByIdRequest,
    GetTrialIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetTrialIdentityByIdResponse, GetTrialIdentityByIdResponse>,
) => response?.data?.trialIdentity;
const getError = (
    response?: SWRResponse<GetTrialIdentityByIdResponse, GetTrialIdentityByIdResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<GetTrialIdentityByIdResponse, GetTrialIdentityByIdResponse>,
) => ({});

const useTrialIdentityById = (
    id?: number | null | undefined,
    configuration?:
        | SWRConfiguration<GetTrialIdentityByIdResponse, GetTrialIdentityByIdResponse>
        | null
        | undefined,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetTrialIdentityByIdResponse> => new GetTrialIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useTrialIdentityById;
